import './FilterGroup.scss';

const getResponsiveColumns = (columns) => {
    if (typeof window === 'undefined') return columns;

    const width = window.innerWidth;
    const minColumns = 2;
    const maxColumns = Math.max(minColumns, columns);
    const calculatedColumns = Math.max(
        minColumns,
        Math.min(maxColumns, Math.floor((width - 32) / 110))
    );

    return Math.min(columns, calculatedColumns);
};

export const FilterGroup = ({ 
    options = [],
    multiselect = false,
    enableNegatives = false,
    columns = 3,
    renderOption = o => o,
    onChange = () => {},
    value
}) => {
    const responsiveColumns = getResponsiveColumns(columns);

    const isActive = (opt) => {
        if (enableNegatives) {
            return value?.positive?.includes(opt);
        } else if(multiselect) {
            return value?.includes(opt);
        } else {
            return value === opt;
        }
    };

    const isNegative = (opt) => {
        if (!enableNegatives) return false;
        
        return value?.negative?.includes(opt);
    }

    const handleOptionClick = (opt) => {
        if (enableNegatives) {
            if (isActive(opt)) {
                onChange({
                    positive: value?.positive.filter(o => o !== opt),
                    negative: [
                        ...(value?.negative || []),
                        opt
                    ]
                })
            } else if (isNegative(opt)) {
                onChange({
                    positive: value?.positive,
                    negative: value?.negative.filter(o => o !== opt)
                })
            } else {
                onChange({
                    positive: [
                        ...(value?.positive || []),
                        opt
                    ],
                    negative: value?.negative
                })
            }
        } else if (multiselect) {
            onChange(
                value && value.includes(opt) ? 
                    value.filter(o => o !== opt) 
                : 
                    [...(value || []), opt]
            )
        } else {
            onChange(value === opt ? null : opt);
        }
    };

    return (
        <div
            className="FilterGroup"
            style={{
                gridTemplateColumns: `repeat(${responsiveColumns}, minmax(0, 1fr))`
            }}
        >
            {options.map(opt => {
                const label = renderOption(opt);

                return (
                    <button
                        key={opt}
                        title={typeof label === 'string' ? label : ''}
                        className={`
                            ${isActive(opt) ? 'active' : ''}
                            ${isNegative(opt) ? 'negative' : ''}
                        `}
                        onClick={() => handleOptionClick(opt)}
                    >
                        {label}
                    </button>
                );
            })}
        </div>
    );
};